mmf_modules.define('app/tos/view',['require','exports','module','jquery','api/tos','api/userTOSAcceptance','context_vars/utils/user','utils/tracking','plugins/qtip'],function (require, exports, module) {

  var $ = require('jquery');
  var tosAPI = require('api/tos');
  var tosAcceptanceAPI = require('api/userTOSAcceptance');
  var ctx_user = require('context_vars/utils/user');
  var tracking = require('utils/tracking');
  require('plugins/qtip');

  var $tosModal;

  function getConfig (content) {
    return {
      content: {
        button: true,
        title: 'Terms & Privacy Update',
        text: $(content)
      },
      hide: {
        event: false
      },
      position: {
        my: 'center',
        at: 'center',
        target: $(window)
      },
      show: {
        modal: {
          blur: false,
          escape: false,
          on: true
        }
      },
      style: {
        classes: 'qtip-light largetip TOSModal',
        width: window.innerWidth < 360 ? 'auto' : 400
      },
      events: {
        toggle: function (event, api) {
          tracking.forceClickTrack('tosModal', event.type); // tooltipshow or tooltiphide
        }
      }
    };
  }

  function createModalContent (tos) {

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', tosAPI.getOverviewLink(tos));
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '400px');

    var iframeWrapper = document.createElement('div');
    iframeWrapper.className = 'TOSModal_Content';
    iframeWrapper.appendChild(iframe);

    var accept = document.createElement('a');
    accept.className = 'TOSModal_Accept';
    accept.textContent = 'Accept';
    accept.addEventListener('click', function (e) {
      e.preventDefault();
      tosAcceptanceAPI.update(ctx_user.id, tos);
      tracking.forceClickTrack('tosModal', 'accept');
      $tosModal.qtip('api').hide();
    });

    var more = document.createElement('a');
    more.className = 'TOSModal_More';
    more.textContent = 'More';
    more.addEventListener('click', function (e) {
      e.preventDefault();
      tracking.forceClickTrack('tosModal', 'more');
      window.open(tosAPI.getHTMLLink(tos));
    });

    var buttonContainer = document.createElement('div');
    buttonContainer.className = 'TOSModal_ButtonContainer';
    buttonContainer.appendChild(more);
    buttonContainer.appendChild(accept);

    var wrapper = document.createElement('div');
    wrapper.appendChild(iframeWrapper);
    wrapper.appendChild(buttonContainer);

    return wrapper;

  }

  exports.render = function (tos) {

    if (!tos) {
      return;
    }

    var htmlElements = createModalContent(tos);
    var qtipConfig = getConfig(htmlElements);
    $tosModal = $('<div/>').qtip(qtipConfig);
    $tosModal.qtip('api').show();

  };

});

